<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <span>{{ 'select-feed-advice-type.description' | translate }}</span>
  <div class="flex--column">
    <mat-form-field class="flex__child--auto spacing--margin-top">
      <mat-label>{{ 'select-feed-advice-type.label' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="feedAdviceType"
        data-test="select-feedAdviceType"
      >
        <mat-option *ngFor="let type of data.feedAdviceTypes" [value]="type">
          {{ getFeedadviceTypeLabel(type) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</agr-form-dialog>
